export const calcContentPaneHeight = (value: number) => {
  return `calc(100vh - ${value}px)`;
};
